const initialState = {
  orders: {
    orders: [],
    count: 0,
  },
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPDATE_ORDER_DATA":
      return {
        ...state,
        orders: action.payload,
      };
    default:
      return state;
  }
};

export default orderReducer;
